import { PAR_IDS, PAR_TYPES } from "../../web-ordering/pdf-order/constant/promo-types";
import { consultarVoucher } from "./consultar-voucher";

const STATUS_PAR_USADO = "ORDER_USED";

function texto(valor) {
	return valor === undefined || valor === null ? "" : String(valor).trim();
}

export function inferirIdParDoCupom(pares, pedido) {
	const lista = Array.isArray(pares) ? pares : [];
	const idPedidoOtica = texto(pedido?.idPedidoOtica);

	if (idPedidoOtica) {
		const mesmoPedidoOtica = lista.filter(par => texto(par.idPedidoOtica) === idPedidoOtica);
		if (mesmoPedidoOtica.length === 1) return texto(mesmoPedidoOtica[0].idPar);
	}

	const usados = lista.filter(par => par.status === STATUS_PAR_USADO);
	if (usados.length === 1) return texto(usados[0].idPar);

	return "";
}

export function montarParInfo(idPar, paresQtd) {
	if (texto(idPar) === PAR_IDS.PAR_2) return PAR_TYPES.PAR_2;
	if (texto(idPar) === PAR_IDS.PAR_1 && texto(paresQtd) === "2") return PAR_TYPES.PAR_1;
	return "";
}

export async function resolverParDoPedido(pedido) {
	const promocao = pedido?.promocao || {};
	let idPar = texto(promocao.idPar);
	let paresQtd = null;

	if (promocao.voucher && idPar !== PAR_IDS.PAR_2) {
		const cupom = await consultarVoucher(promocao.voucher);
		if (cupom.success) {
			paresQtd = cupom.paresQtd ?? null;
			if (!idPar) idPar = inferirIdParDoCupom(cupom.pares, pedido);
		}
	}

	return { idPar, paresQtd, parInfo: montarParInfo(idPar, paresQtd) };
}
